import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import UnAuthorizedLayout from "../../../layout/unauth/UnAuthorizedLayout";
import ChangePasswordPage from "./ChangePasswordPage";
import TokenPage from "./TokenPage";
import { PasswordChangeForm } from "../../../../app/models/user";
import ForgotPassword from "./ForgotPassword";
import ResetPassword from "./ResetPassword";

const ChangePasswordStepPage = () => {
  const [step, setStep] = useState(0);
  const [inputField, setInputField] = useState(new PasswordChangeForm());
  // Proceed to next step
  const nextStep = () => {
    return setStep(step + 1);
  };
  // Go back to prev step
  const prevStep = () => {
    return setStep(step - 1);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputField({ ...inputField, [e.target.name]: e.target.value });
  };

  switch (step) {
    case 0:
      return (
        <UnAuthorizedLayout>
          <ForgotPassword
            setStep={setStep}
            inputField={inputField}
            setInputField={setInputField}
            nextStep={nextStep}
          />
        </UnAuthorizedLayout>
      );
    case 1:
      return (
        <UnAuthorizedLayout>
          <ResetPassword
            setStep={setStep}
            inputField={inputField}
            setInputField={setInputField}
            nextStep={nextStep}
          />
        </UnAuthorizedLayout>
      );
    default:
      return <ChangePasswordStepPage />;
  }
};

export default observer(ChangePasswordStepPage);
